import { Pipe, PipeTransform } from '@angular/core'
import { invalidPipeArgumentError } from './invalid-pipe-argument-error'
import { parseDate } from '../utils/date.util'
import { get } from 'lodash';
import { format } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

@Pipe({
    name: 'date',
    standalone: false
})
export class DatePipe implements PipeTransform {
  transform(value: any, options: {}): string {
    if (value == null) {
      return 'n/a'
    }

    const date = parseDate(value)
    const pattern = get(options, 'pattern') || 'MMM d, yyyy'
    const timezone = get(options, 'timezone')

    try {
      if (timezone === 'UTC') {
        return formatInTimeZone(date, 'UTC', pattern)
      }
      return format(date, pattern)
    } catch(e) {
      throw invalidPipeArgumentError('date', value)
    }
  }
}
